import { useEffect, useState } from 'react';
import { useApi } from '../../lib/api';

type Seller = {
  user_id: string;
  email: string;
  full_name: string | null;
  seller_status: string;
  payouts_enabled: number;
  refund_disputes: number;
  active_listings: number;
};

export default function AdminSellers() {
  const api = useApi();
  const [sellers, setSellers] = useState<Seller[]>([]);
  const [busy, setBusy] = useState<string | null>(null);

  async function refresh() {
    const { sellers } = await api<{ sellers: Seller[] }>('/admin/sellers');
    setSellers(sellers);
  }
  useEffect(() => {
    refresh().catch(console.error);
  }, []);

  async function suspend(id: string) {
    const reason = window.prompt('Reason for suspension (optional):') ?? undefined;
    if (reason === undefined && !window.confirm('Suspend this seller?')) return;
    setBusy(id);
    try {
      await api(`/admin/sellers/${id}/suspend`, {
        method: 'POST',
        body: JSON.stringify({ reason }),
      });
      await refresh();
    } finally {
      setBusy(null);
    }
  }

  async function reinstate(id: string) {
    setBusy(id);
    try {
      await api(`/admin/sellers/${id}/reinstate`, { method: 'POST' });
      await refresh();
    } finally {
      setBusy(null);
    }
  }

  return (
    <section>
      <h2>Sellers</h2>
      {sellers.length === 0 && <p className="muted">No sellers yet.</p>}
      <div className="grid cols-3">
        {sellers.map((s) => (
          <div className="card" key={s.user_id}>
            <p>
              <strong>{s.full_name ?? '(no name)'}</strong>
            </p>
            <p className="muted">{s.email}</p>
            <p>
              <span className="badge">{s.seller_status}</span>{' '}
              {!s.payouts_enabled && <span className="badge">payouts off</span>}
            </p>
            <p className="muted">
              {s.active_listings} active listing{s.active_listings === 1 ? '' : 's'} ·{' '}
              {s.refund_disputes} refund dispute{s.refund_disputes === 1 ? '' : 's'}
            </p>
            {s.seller_status === 'suspended' ? (
              <button disabled={busy === s.user_id} onClick={() => reinstate(s.user_id)}>
                Reinstate
              </button>
            ) : (
              <button
                className="btn-secondary"
                disabled={busy === s.user_id}
                onClick={() => suspend(s.user_id)}
              >
                Suspend
              </button>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
